(function () {
  function normalise(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function initialise(section) {
    if (section.getAttribute('data-faq-simple-ready') === 'true') return;
    section.setAttribute('data-faq-simple-ready', 'true');
    var input = section.querySelector('[data-faq-search]');
    var clear = section.querySelector('[data-faq-clear]');
    var status = section.querySelector('[data-faq-status]');
    var noResults = section.querySelector('[data-faq-no-results]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-faq-item]'));
    var groups = Array.prototype.slice.call(section.querySelectorAll('[data-faq-group]'));
    var filters = Array.prototype.slice.call(section.querySelectorAll('[data-faq-filter]'));
    var activeCategory = 'all';

    if (!input || !items.length) return;

    items.forEach(function (item) {
      item._tanFaqSearchText = normalise(item.getAttribute('data-search-text') || item.textContent);
    });

    function setActiveFilter(category) {
      activeCategory = category || 'all';
      filters.forEach(function (button) {
        var isActive = button.getAttribute('data-faq-filter') === activeCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function update() {
      var query = normalise(input.value);
      var matches = 0;

      items.forEach(function (item) {
        var categoryMatches = activeCategory === 'all' || item.getAttribute('data-faq-category') === activeCategory;
        var searchMatches = !query || item._tanFaqSearchText.indexOf(query) !== -1;
        var visible = query ? searchMatches : categoryMatches;
        item.hidden = !visible;
        if (visible) matches += 1;
      });

      groups.forEach(function (group) {
        var groupItems = Array.prototype.slice.call(group.querySelectorAll('[data-faq-item]'));
        var hasVisibleItem = groupItems.some(function (item) { return !item.hidden; });
        group.hidden = !hasVisibleItem;
      });

      clear.hidden = !query;
      noResults.hidden = matches > 0;

      if (!query) {
        status.textContent = '';
      } else if (matches === 0) {
        status.textContent = section.getAttribute('data-no-result') || '';
      } else if (matches === 1) {
        status.textContent = (section.getAttribute('data-result-singular') || '').replace('{count}', String(matches));
      } else {
        var plural = section.getAttribute('data-result-plural') || '';
        status.textContent = plural.indexOf('{count}') !== -1
          ? plural.replace('{count}', String(matches))
          : (matches + ' ' + plural).trim();
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = '';
        setActiveFilter(button.getAttribute('data-faq-filter'));
        update();
      });
    });

    input.addEventListener('input', update);
    input.addEventListener('search', update);
    clear.addEventListener('click', function () {
      input.value = '';
      update();
      input.focus();
    });

    setActiveFilter('all');
    update();
  }

  function start(scope) {
    scope = scope || document;
    if (scope.matches && scope.matches('[data-faq-simple]')) initialise(scope);
    Array.prototype.forEach.call(scope.querySelectorAll ? scope.querySelectorAll('[data-faq-simple]') : [], initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (event) { start(event.target); });
})();
